var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 13.75C6.25 11.8502 6.25106 10.4757 6.39199 9.42754C6.53098 8.39373 6.79772 7.75253 7.27513 7.27513C7.75253 6.79772 8.39373 6.53098 9.42754 6.39199C10.4757 6.25106 11.8502 6.25 13.75 6.25H32.25C34.1498 6.25 35.5243 6.25106 36.5725 6.39199C37.6063 6.53098 38.2475 6.79772 38.7249 7.27513C39.2023 7.75253 39.469 8.39373 39.608 9.42754C39.7489 10.4757 39.75 11.8502 39.75 13.75V32.25C39.75 34.1498 39.7489 35.5243 39.608 36.5725C39.469 37.6063 39.2023 38.2475 38.7249 38.7249C38.2475 39.2023 37.6063 39.469 36.5725 39.608C35.5243 39.7489 34.1498 39.75 32.25 39.75H13.75C11.8502 39.75 10.4757 39.7489 9.42754 39.608C8.39373 39.469 7.75253 39.2023 7.27513 38.7249C6.79772 38.2475 6.53098 37.6063 6.39199 36.5725C6.25106 35.5243 6.25 34.1498 6.25 32.25V13.75Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15.333L23 30.6663",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6665 23L15.3332 23",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSquare);
export default __webpack_public_path__ + "static/media/add-square.4b378b126b87dc8956062dacdaa6d826.svg";
export { ForwardRef as ReactComponent };